import { notify } from "../../../utils/notify";
import { sendHubDocumentsV2 } from "../../documentModal/controllers/DocumentModal";
import { convertCompetence, convertDate } from "../utils/DocumentDataConverter";

export const useDocumentDialogController = () => {
  const sendDocument = async (
    documentData,
    listDocuments,
    setListDocuments,
    index,
    setDisabled,
    onClose
  ) => {
    setDisabled(true);
    try {
      let body = {
        ...documentData,
        competence: convertCompetence(documentData.competence),
        emissionDate: convertDate(documentData.emissionDate),
        dueDate: convertDate(documentData.dueDate),
        sendTo: documentData?.sendTo?.document,
      };

      if (!body.relatedEntity?.document || !body.relatedEntity?.name) {
        if (body.movementType === "PAYABLE") {
          body.relatedEntity = {
            document: body?.supplierDocument
              ? body?.supplierDocument.replace(/\W/g, "")
              : "",
            name: body?.supplierName,
          };
        } else {
          body.relatedEntity = {
            document: body.customerData?.document
              ? body.customerData?.document.replace(/\W/g, "")
              : "",
            name: body.customerData?.company_name,
          };
        }
      }

      if (body.relatedEntity?.document) {
        body.relatedEntity.document = body.relatedEntity.document.replace(
          /\W/g,
          ""
        );
      }

      const validationResult = validateBodySendDocument(body);

      if (validationResult.result) {
        const response = await sendHubDocumentsV2(body);

        if (response?.success) {
          notify("Documento enviado com sucesso!", true, "success");

          const newDocumentList = [...listDocuments];

          if (index + 1 === listDocuments.length) {
            window.document
              .getElementsByClassName("control-arrow control-prev")[0]
              .click();
          }

          newDocumentList.splice(index, 1);
          setListDocuments(newDocumentList);

          setDisabled(false);

          if (newDocumentList.length === 0) {
            onClose();
          }
        } else {
          notify(response?.message, true, "error");
          setDisabled(false);
        }
      } else {
        notify(validationResult.message, true, "error");
        setDisabled(false);
      }
    } catch (e) {
      setDisabled(false);

      console.log(e);
    }
  };

  const validateBodySendDocument = (body) => {
    if (body.documentType === "OTHER") {
      if (!body?.description) {
        return {
          result: false,
          message: "Insira uma descrição válida",
        };
      }
    } else {
      if (!body?.description) {
        return {
          result: false,
          message: "Insira uma descrição válida",
        };
      }

      if (!body?.dueDate) {
        return {
          result: false,
          message: "Insira uma data de vencimento válida",
        };
      }

      if (
        body.dueDate.length !== 10 ||
        body.dueDate.substring(5, 7) > 12 ||
        body.dueDate.substring(8, 10) > 31
      ) {
        return {
          result: false,
          message: "Insira uma data de vencimento válida",
        };
      }

      if (body?.emissionDate) {
        if (
          body.emissionDate.length !== 10 ||
          body.emissionDate.substring(5, 7) > 12 ||
          body.emissionDate.substring(8, 10) > 31
        ) {
          return {
            result: false,
            message: "Insira uma data de emissão válida",
          };
        }
      }

      if (body?.competence) {
        if (
          body.competence.length !== 7 ||
          body.competence.substring(5, 7) > 12
        ) {
          return {
            result: false,
            message: "Insira uma competência válida!",
          };
        }
      }

      if (typeof body?.grossAmount !== "number") {
        return {
          result: false,
          message: "Insira o valor bruto!",
        };
      }

      if (typeof body?.netAmount !== "number") {
        return false;
      }

      if (typeof body?.discountAmount !== "number") {
        return {
          result: false,
          message: "Insira o valor do desconto!",
        };
      }

      if (typeof body?.fineAmount !== "number") {
        return {
          result: false,
          message: "Insira o valor da multa!",
        };
      }

      if (typeof body?.interestAmount !== "number") {
        return {
          result: false,
          message: "Insira o valor dos juros!",
        };
      }

      if (!body?.relatedEntity?.document) {
        return {
          result: false,
          message:
            "Insira os dados do " +
            (body.movementType === "PAYABLE" ? "fornecedor" : "cliente"),
        };
      }
    }

    if (!body?.folderSystem) {
      return {
        result: false,
        message: "Escolha uma pasta de destino válida!",
      };
    }

    if (body.folderType === "doc") {
      if (
        body?.folderSystem !== "contratoTrabalho" &&
        body?.folderSystem !== "contratoSocial" &&
        body?.folderSystem !== "outros"
      ) {
        return {
          result: false,
          message: "Escolha uma pasta de destino válida!",
        };
      }
    } else {
      if (
        body?.folderSystem !== "contabil" &&
        body?.folderSystem !== "fiscal" &&
        body?.folderSystem !== "folha" &&
        body?.folderSystem !== "outros"
      ) {
        return {
          result: false,
          message: "Escolha uma pasta de destino válida!",
        };
      }
    }

    if (!body.sendTo) {
      return {
        result: false,
        message: "Selecione a empresa para envio do documento!",
      };
    }

    return {
      result: true,
      message: "Documento válido!",
    };
  };

  return {
    sendDocument,
  };
};
